import Personalize from '@contentstack/personalize-edge-sdk';

import { HttpClient } from 'services/http';

import { ensureDefined } from 'utils/assert';
import { GATSBY_SOURCE_CONTENTSTACK_PREFIX } from 'utils/constants';
import { convertKeysToCamelCase } from 'utils/livePreviewUtils';

const PERSONALIZE_API_URL = 'https://cdn.contentstack.io/v3';

export async function fetchPersonalizeData<T>(contentType: string, uid: string): Promise<T> {
  const parsedContentType = contentType.replace(GATSBY_SOURCE_CONTENTSTACK_PREFIX, '');
  const contentstackEnv = ensureDefined(process.env.GATSBY_CONTENTSTACK_ENVIRONMENT);

  if (!contentType || !uid) {
    throw new Error('Missing contentType or uid for personalization API call.');
  }

  const response = await HttpClient.get(
    `${PERSONALIZE_API_URL}/content_types/${parsedContentType}/entries/${uid}?environment=${contentstackEnv}&include_all=true`,
    {
      headers: {
        'Content-Type': 'application/json',
        api_key: process.env.GATSBY_CONTENTSTACK_API_KEY!,
        access_token: process.env.GATSBY_CONTENTSTACK_DELIVERY_TOKEN!,
        'x-cs-variant-uid': Personalize.getVariantAliases().join(','),
      },
    }
  );
  const data = await response.json();

  return convertKeysToCamelCase(data.entry);
}
